// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3EkN0{margin-top:2rem;margin-right:auto;margin-left:auto}@media(max-width:1023px){._3EkN0{max-width:calc(100% - 4rem);margin-top:2.5rem;padding-left:0}}@media(max-width:767px){._3EkN0{max-width:calc(100% - 2rem);margin-top:1.5rem;padding-left:0}}._1UrqI{position:fixed;left:0;z-index:1;background-color:#fff;-webkit-box-shadow:0 4px 4px 0 rgba(35,24,21,.16);box-shadow:0 4px 4px 0 rgba(35,24,21,.16);width:100vw}.a4_ex{position:sticky}._1c9ch{width:100%}._1c9ch h2{margin-bottom:1.5rem;font-size:24px;font-weight:500;line-height:30px;font-family:var(--heading-font);letter-spacing:.5px}@media(max-width:767px){._1c9ch h2{font-size:20px;line-height:25px}}._1c9ch section{padding-bottom:2.5rem}._3mDPr{max-width:var(--max-content-width);z-index:1}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_3EkN0",
	"shadow": "_1UrqI",
	"tabsWrapper": "a4_ex",
	"contentWrapper": "_1c9ch",
	"stickyTabsWrapper": "_3mDPr"
};
module.exports = exports;
